import {
  OPEN_CONTACT_US_MODAL,
  CLOSE_CONTACT_US_MODAL,
  TOGGLE_TERMS_OF_SERVICES_MODAL,
  TOGGLE_FORGOT_PASSWORD_MODAL,
  TOGGLE_TUTORIAL_MODAL,
} from './types';

import { createReduxAction } from '../utils';

export const openContactUsModal = createReduxAction(OPEN_CONTACT_US_MODAL);
export const closeContactUsModal = createReduxAction(CLOSE_CONTACT_US_MODAL);

export const toggleTermsOfServicesModal = createReduxAction(
  TOGGLE_TERMS_OF_SERVICES_MODAL,
);

export const toggleForgotPasswordModal = createReduxAction(
  TOGGLE_FORGOT_PASSWORD_MODAL,
);

export const toggleTutorialModal = createReduxAction(TOGGLE_TUTORIAL_MODAL);



// WEBPACK FOOTER //
// ./src/store/modules/modals/actions.js